import { useMutation } from "@tanstack/react-query";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import { saveOrganizationStructureForm } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api";
import { IEmployeeDataSave } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/Forms/OrganizationStructureForm.models";

export const useSaveOrganizationStructureForm = (
  companyId: string,
  employeeId: string
) =>
  useMutation({
    mutationFn: async (formData: IEmployeeDataSave) =>
      saveOrganizationStructureForm(companyId, employeeId, formData),
    onError: () => {
      dynamicNotification(__("Błąd aktualizacji danych"), "error");
    },
  });
